import { AfterViewInit, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { IAuthStatusEnum } from '@features/auth/interfaces/auth.interface';
import { AuthService } from '@features/auth/services/auth.service';
import { LoaderGlobal } from '@shared/components/loaders/loader-global/loader-global';

@Component({
  selector: 'app-root',
  imports: [LoaderGlobal,RouterOutlet],
  templateUrl: './app.html',
})
export class App implements AfterViewInit {
  _authService = inject(AuthService);
  _loaderService = inject(LoaderService);

  showLoader = computed(() => {
    if (this._authService.authStatus() === IAuthStatusEnum.checking) return true;
    if (this._loaderService._loaderOpened()) return true;
    return false;
  });

  ngAfterViewInit() {
    // Por id: 'app-boot-loader' es el loader estatico de index.html. Con selector de
    // clase se corria el riesgo de borrar el <app-loader-global> de Angular, que usa
    // la misma clase y ahora se muestra tambien durante la navegacion.
    document.getElementById('app-boot-loader')?.remove();
  }
}
